import { PlusOutlined } from '@ant-design/icons';
import { useQuery } from '@apollo/client';
import { Button } from 'antd';
import { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import {
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
  ROUTES,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import GoBackButton from '../../../../../components/GoBackButton';
import Portal from '../../../../../components/Portal';
import StaffTable from '../../../../users/modules/staff/components/StaffTable';
import { LIBRARY_STAFF_BASE_PATH } from '../../../../users/modules/staff/staffConfig';
import LibraryTabs from '../components/LibraryTabs';
import { LIBRARY_NAME_ADMIN } from '../graphql/Queries';

const LibraryStaff = ({
  match: { params: { id, libraryNumber } = {} } = {},
}) => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const history = useHistory();
  const location = useLocation();
  const isView = location?.pathname?.includes('/view/');

  const { data: { libraryAdmin: library } = {} } = useQuery(
    LIBRARY_NAME_ADMIN,
    { variables: { where: { id } }, fetchPolicy: 'network-only' },
  );

  const canCreate = hasPermission(
    PERMISSIONS_KEY?.SYSTEM_USERS_ADMINS,
    PERMISSION_TYPE?.CREATE,
    permissions,
  );

  const handleAdd = () => {
    history?.push(`${LIBRARY_STAFF_BASE_PATH}/add`, {
      returnPath: location?.pathname,
      library: library && {
        id: library?.id,
        name: library?.name,
        libraryNumber: library?.libraryNumber,
      },
    });
  };

  const addButton = canCreate && (
    <Button
      className="common-button"
      size="middle"
      icon={<PlusOutlined />}
      onClick={handleAdd}
      disabled={!library}
    >
      Add New Staff
    </Button>
  );

  return (
    <>
      <Portal portalId="header-title-content">
        <GoBackButton
          customLink={`${ROUTES?.MASTER_LISTS}${ROUTES?.LIBRARY}`}
        />
        <div className="portal-header">
          {isView ? 'View Library' : 'Edit Library'}
        </div>
      </Portal>
      <Portal portalId="header-right-content">{addButton}</Portal>
      <Portal portalId="header-right-content-phones">{addButton}</Portal>

      <LibraryTabs libraryId={id} libraryNumber={libraryNumber} isView={isView}>
        <div className="full-height-without-details">
          <StaffTable
            libraryId={id}
            returnPath={location?.pathname}
          />
        </div>
      </LibraryTabs>
    </>
  );
};

export default LibraryStaff;
